import { createRef, useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Dropdown, Form, Row } from "react-bootstrap";
// img
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CHATTER_CLIENT_LIST, CLIENT_REPORTS_LIST } from "config/paths";
import { Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, errorMessageToast, getAge, getPdfBlob, ReportsNoRecordMessage, successMessageToast, userFullName } from "helpers/common";
import { CHATTER_CONSULTATION_REPORT_V2_QUESTIONS, CLIENT_REPORT_TYPES, dobFormat, REPORT_IDS, reportDateFormat } from "config/constants";
import moment from "moment";
import GuardianDetailList from "components/shared/ReportsV2/GuardianDetailsList";
import { useUploadFileMutation } from "store/services/utility";
import { useCopyReportsMutation, useGetReportClientsAssessmentFeedbackQuery } from "store/services/clients/reports-v2/schoolReports";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import ClientDetails from "components/shared/ReportsV2/ClientDetails";
import { ArrowLeftIcon } from "Assets/icons";
import RenderQuestion from "components/shared/ReportsV2/Questions/Index";
import { formatReportFeedbackV2, reportInitialValuesV2 } from "helpers/assessment";
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import QuestionMultipleRecommendation from "components/shared/ReportsV2/Questions/QuestionMultipleRecommendation";
import { toPng } from "html-to-image";
import getValidationSchema from "./validation";
import { cloneDeep, isEmpty } from "lodash";
import ReportSubmitButton from "components/shared/ReportsV2/ReportSubmitButton";
import ReportError from "components/shared/ReportsV2/ReportError";
import TabStepper from "components/shared/ReportsV2/TabStepper";
import { useGetChatterProgramsListQuery } from "store/services/clients/chatter";
import { useSubmitChatterConsulatitonReportMutation } from "store/services/clients/reports-v2/chatterReports";
import ChatterConsultationReportPdfDocV2 from "components/PDF/Clients/ReportsV2/ChatterConsultationReportPdfDocV2";
import QuestionMultipleGoalsStrategy from "components/shared/ReportsV2/Questions/QuestionMultipleGoalsStrategy";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import confirmDialogV2 from "utils/confirmationDialogV2";
import ClassroomReportDateModal from "components/Modals/ClassroomReportDateModalV2";
import ChatterGuardianDetailList from "components/shared/ReportsV2/ChatterGuardianDetailList";

const ChatterConsultationReport = () => {
  const navigate = useNavigate();
  const sliderRefs = useRef([]);
  const [previewMode, setPreviewMode] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [goalSubmissionError, setGoalSubmissionError] = useState(null);
  const [chartImages, setChartImages] = useState(null);
  const { assessmentId, clientId, reportId } = useParams();
  const [copyReportDateModal, setCopyReportDateModal] = useState(false)
  const [currentEntry, setCurrentEntry] = useState(null)
  const clientType = "chatter"

  const [reportHeading, setReportHeading] = useState(CLIENT_REPORT_TYPES[REPORT_IDS.CHATTER_CONSULATION_REPORT_V2]?.title);

  const [submitReport, { isLoading: submitReportLoading }] = useSubmitChatterConsulatitonReportMutation();
  const { data, isLoading, isFetching, isError, refetch } = useGetReportClientsAssessmentFeedbackQuery({ reportId: REPORT_IDS.CHATTER_CONSULATION_REPORT_V2, clientId, clientType: "chatter", submittedReportId: reportId });
  const [copyReport, { isLoading: copyReportLoading }] = useCopyReportsMutation()
  const [document, setDocument] = useState(null)
  const [currentTab, setCurrentTab] = useState(1)
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [programValidation, setProgramValidation] = useState(null);
  const [publishPdfModal, setPublishPdfModal] = useState(false);

  const assessmentAssignedId = data?.assesment?.id;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const showDOB = true
  const guardian = {}
  const reportGoals = data?.assesmentData?.reportGoals;
  const reportRecommendations = data?.assesmentData?.reportRecommendations;

  const therapist = useSelector((state) => state?.auth?.user)
  const otherTherapists = data?.clientPendingCaseload?.clientCaseloadTherapist?.filter((item) => item?.clientCaseloadMapping[0]?.therapist_id != therapist?.id)

  const currentCaseload = data?.clientPendingCaseload?.clientCaseloadTherapist?.find((item) => item?.discipline_id == therapist?.therapist_discipline?.id)

  console.log('currentCaseload', currentCaseload)

  const caseDiscipline = currentCaseload?.caseDiscipline;
  const caseApprentice = currentCaseload?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "apprentice");
  const caseVeteran = currentCaseload?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran");

  console.log('caseApprentice', caseApprentice)
  console.log('otherTherapists', otherTherapists)

  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation();
  const { data: assignedProgramsList, isLoading: clientProgramsLoading } = useGetChatterProgramsListQuery({ id: clientId });
  const clientProgramList = assignedProgramsList?.Records || []

  const chartRefs = useRef([]);
  const formRefs = useMemo(() => {
    if (!reportGoals?.length) return [];
    return reportGoals?.map((goal) => {
      return createRef();
    });
  }, [reportGoals]);

  // const handleSelectProgram = (id) => {
  //   const program = clientProgramList?.find((item) => item?.id == id)
  //   if (program) {
  //     const data = cloneDeep(program)
  //     data.leaders = [program?.program_head_one, program?.program_head_two]
  //     setSelectedProgram(data)
  //     setProgramValidation(null)
  //   }
  //   else {
  //     setSelectedProgram([])
  //   }
  // }

  const handleSelectProgram = (selected) => {
    const program = selected.program;
    if (program) {
      const data = cloneDeep(program)
      data.leaders = [program?.program_head_one, program?.program_head_two]
      setSelectedProgram(data)
      setProgramValidation(null)
    }
    else {
      setSelectedProgram([])
    }
  }

  const initialValues = useMemo(() => {
    if (!data) return {};
    const guardianList = data?.assesment?.AssesmentGuardianAssigned?.map((item) => ({ id: item?.AssessmentReportGuardians?.id, role: item?.role }))
    let answers = data?.assesmentData?.reportAnswers;
    let values = {
      screening_date: data?.assesment?.screening_date || new Date(),
      apprentice_id: data?.assesment?.studentSignatureId,
      student: data?.assesment?.studentSignatureId ? { label: userFullName(caseApprentice?.caseTherapist), value: data?.assesment?.studentSignatureId } : null,
      signatureBy: data?.assesment?.signatureBy || null,
      guardianList,
      recommendation: data?.assesmentData?.reportRecommendations?.length ? data?.assesmentData?.reportRecommendations?.map((item) => ({ id: item?.id || null, answers: item?.answers, attachmentData: item?.attachmentData ? JSON.parse(item?.attachmentData) : [] })) : [{ answers: "" }],
      observations: data?.assesmentData?.reportObservations?.length ? data?.assesmentData?.reportObservations?.map((item) => ({ id: item?.id, notes: item?.notes || "", tracker_percentage: item?.tracker_percentage || 0, show_tracker: item?.show_tracker || "show", obs_date: item?.obs_date || null, area_id: item?.area_id, goal_id: item?.goal_id, area_title: item?.AssesmentObservationGoalArea?.name, goal_title: item?.AssesmentObservationGoalDetail?.title, goal_details: item?.goal_details || "", strategy: item?.AssessmentObservationStrategy?.length ? item?.AssessmentObservationStrategy?.map((strategy) => ({ id: strategy?.id, template_id: strategy?.template_id, title: strategy?.TemplateDetail?.title || "", answers: strategy?.answers == "null" ? "" : strategy?.answers || "", attachmentData: strategy?.attachmentData ? JSON.parse(strategy?.attachmentData) : [] })) : [{ answers: "", attachmentData: [] }] })) : [],
      groupLeaderList: data?.assesment?.AssesmentGroupleaderAssigned?.length ? data?.assesment?.AssesmentGroupleaderAssigned?.map((item) => ({ ...item?.AssessmentReportGroupLeaders, chatter_program_id: item?.chatter_program_id })) : [],
      // program: clientProgramList?.find((item) => item?.id == 71)
    };

    // if (data?.assesment?.AssesmentGroupleaderAssigned?.[0]?.chatter_program_id) {
    //   handleSelectProgram(data?.assesment?.AssesmentGroupleaderAssigned?.[0]?.chatter_program_id)
    // }

    values = reportInitialValuesV2(values, reportQuestions, answers);

    return values;
  }, [data, clientProgramList]);


  const validationSchema = useMemo(() => {
    return getValidationSchema(currentTab, reportQuestions)
  }, [reportQuestions, currentTab]);

  const handleSubmitStep = async (values) => {
    setSubmitting(true);

    try {
      let payload = formatReportFeedbackV2(reportHeading, reportQuestions, { ...values });

      const currentStep = currentTab == 1 ? "client_info" : currentTab == 2 ? "program_info" : currentTab == 3 ? "program_goals" : currentTab == 4 ? "recommendation" : "";

      let body = {
        goals: [],
        current_step: values?.saveForLater ? currentStep : "submit_and_email",
        assesment_location: "in-person",
        feedbacks: payload.feedbacks,
        screening_date: values?.screening_date,
        report_heading: reportHeading,
        guardianList: values?.guardianList,
        recommendation: values?.recommendation,
        signatureBy: values?.signatureBy,
        observations: values?.observations,
        groupLeaderList: values?.groupLeaderList?.length ? values?.groupLeaderList?.map((item) => ({ id: item?.id, chatter_program_id: item?.chatter_program_id })) : []
      };

      // save chart images for later use
      if (currentTab == 3) {
        const sliderImages = await getSliderImages();
        console.log('sliderImages', sliderImages)
        if (sliderImages) {
          setChartImages(sliderImages);
        }
      }

      (formRefs?.length && reportGoals?.length) && reportGoals?.forEach((goal, index) => {
        if (!formRefs[index]?.current) return;
        let values = formRefs[index].current.values;
        if (values?.hasUnsavedChanges) {
          setGoalSubmissionError("There are unsaved changes, please save them before proceeding");
          throw new Error("Form contains unsaved changes");
        }

        body.goals.push({
          goal_id: goal.id,
          goal_notes: values?.goal_notes,
          goal_attachementData: values?.goal_attachementData
        })
      });

      setGoalSubmissionError(null);

      if (therapist?.role_type == "apprentice" || values?.saveForLater) {
        body = {
          ...body,
          studentSignatureId: values?.apprentice_id,
          save_for_later: "yes",
        }
      }
      else {

        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
          [...data.client_detail.client_guardian_mapping]
            .map((guardian) => {
              const id = guardian?.client_guardian?.id;
              const role = guardian?.client_guardian?.client_role?.title;

              const matchedGuardian = values?.guardianList?.find(
                (item) => item.id === id
              );

              if (matchedGuardian) {
                return {
                  ...guardian,
                  key: matchedGuardian?.role  // or matchedGuardian.role
                };
              }

              return null;
            })
            .filter(Boolean);

        const pdfData = {
          ...body,
          clientId: data?.id,
          lastname: data?.lastname,
          firstname: data?.firstname,
          city_town: data?.client_detail?.city_town,
          dob: dateFormat(data?.client_detail?.dob),
          age: getAge(data?.client_detail?.dob),
          grade: data?.client_detail?.grade,
          schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
          schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
          screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
          selectedGuardians,
          reportHeading,
          therapist,
          apprentice: values?.apprentice_id,
          caseApprentice,
          therapistSignature: therapist?.signature_img,
          emailSignature: therapist?.email_signature,
          reportDate: moment(new Date()).format("MMMM D, YYYY"),
          reportQuestions: data?.assesmentData?.reportQuestions,
          reportAnswers: data?.assesmentData?.reportAnswers,
          assessmentGoals: reportGoals,
          images: chartImages,
          observations: values?.observations,
          recommendation: values?.recommendation,
          groupLeaderList: values?.groupLeaderList || [],
          otherTherapists,
          feedbacks: {
            [CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary]: values[CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary],
          },
        }

        const doc = (
          <ChatterConsultationReportPdfDocV2
            data={pdfData}
          />
        )

        // setDocument(doc)

        const filename = `Chatter Program Summary Report - ${caseDiscipline?.assign_term} - ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
        let pdfFile = await getPdfBlob(doc, false, filename);

        let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

        if (!uploadedFileName) {
          throw new Error("File not uploaded");
        };


        body = {
          ...body,
          emailFormData: values?.emailFormData,
          pdfData: [{
            attachment_key: uploadedFileName,
            attachment_name: CLIENT_REPORT_TYPES[assessmentId]?.name || "Chatter Program Summary Report",
          }],
        }
      }

      const response = await submitReport({ data: body, clientId: assessmentAssignedId }).unwrap()
      refetch()
      setSubmitting(false);
      successMessageToast(response.message)
      if (!values?.saveForLater) {
        navigate(CHATTER_CLIENT_LIST)
      }
    } catch (error) {
      setSubmitting(false);
      console.log('error', error)
    }
  };

  const handleViewPdf = async (values) => {
    const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
      [...data.client_detail.client_guardian_mapping]
        .map((guardian) => {
          const id = guardian?.client_guardian?.id;
          const role = guardian?.client_guardian?.client_role?.title;

          const matchedGuardian = values?.guardianList?.find(
            (item) => item.id === id
          );

          if (matchedGuardian) {
            return {
              ...guardian,
              key: matchedGuardian?.role  // or matchedGuardian.role
            };
          }

          return null;
        })
        .filter(Boolean);

    const pdfData = {
      clientId: data?.id,
      lastname: data?.lastname,
      firstname: data?.firstname,
      city_town: data?.client_detail?.city_town,
      dob: dateFormat(data?.client_detail?.dob),
      age: getAge(data?.client_detail?.dob),
      grade: data?.client_detail?.grade,
      schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
      schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
      screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
      selectedGuardians,
      reportHeading,
      therapist,
      apprentice: values?.apprentice_id,
      caseApprentice,
      therapistSignature: therapist?.signature_img,
      emailSignature: therapist?.email_signature,
      reportDate: values?.screening_date ? moment(values?.screening_date).format("MMMM D, YYYY") : null,
      reportQuestions: data?.assesmentData?.reportQuestions,
      reportAnswers: data?.assesmentData?.reportAnswers,
      assessmentGoals: reportGoals,
      images: chartImages,
      observations: values?.observations,
      recommendation: values?.recommendation,
      groupLeaderList: values?.groupLeaderList || [],
      otherTherapists,
      feedbacks: {
        [CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary]: values[CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary],
      },
    }

    const doc = (
      <ChatterConsultationReportPdfDocV2
        data={pdfData}
      />
    )

    setDocument(doc)
    setPdfModal(true)

  };

  const getChartImages = async () => {
    if (!chartRefs.current?.length) {
      return null;
    }
    return await Promise.all(
      chartRefs.current.map(async (ref) => {
        if (ref) {
          return await ref.generateImage();
        }
        return null;
      })
    );
  }

  const getSliderImages = async () => {
    if (!sliderRefs.current?.length) return null;

    return await Promise.all(
      sliderRefs.current.map(async (ref) => {
        if (ref) {
          try {
            return await toPng(ref, { pixelRatio: 2 });
          } catch (error) {
            console.error('Error generating slider image:', error);
            return null;
          }
        }
        return null;
      })
    );
  };

  const handleCopyReportApi = async (reportId, assessmentId, screening_date) => {
    const reportType = CLIENT_REPORT_TYPES[assessmentId]?.copyType
    console.log('assessmentId for reort ', assessmentId)
    try {
      await copyReport({ clientId, clientType, reportId, reportType, assessmentId, screening_date }).unwrap()
      if (copyReportDateModal) {
        setCopyReportDateModal(false)
      }
      navigate(generatePath(CLIENT_REPORTS_LIST, { clientId, clientType }))
    } catch (error) {
      console.log('error copying report:', error)
    }
  }

  const handleCopyReport = async (e, reportId, assessmentId) => {
    e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "MAKE A COPY",
      message: `A copy of this report will be added to your list with ${moment().format(reportDateFormat)} as the Report Date.`,
    });
    if (!isConfirm) {
      setCopyReportDateModal(true)
      return
    }
    else {
      handleCopyReportApi(reportId, assessmentId, moment(new Date()).format("YYYY-MM-DD"))
    }
  }

  return (
    <>
      <ClassroomReportDateModal
        show={copyReportDateModal}
        setShow={setCopyReportDateModal}
        isLoading={copyReportLoading}
        currentEntry={currentEntry}
        handleCopyReportApi={handleCopyReportApi}
        type='chatter'
      />
      {/* <PDFDocViewer doc={<ConsultationReportPdfDocV2 />} /> */}
      {/* <Row>
        <Col lg="6">
          <img style={{width: "100%"}} src={example?.[0]} alt="hhfiufufuf" />
        </Col>
      </Row> */}
      <section className="ReportSec proxima container-discharge-screen py-3 position-relative">
        <Container fluid>
          <div style={{ maxWidth: "80%", margin: "0 auto" }}>
            <Formik
              initialValues={initialValues}
              onSubmit={handleSubmitStep}
              validationSchema={validationSchema}
              enableReinitialize
            >
              {({ handleSubmit, values, errors, touched, setFieldValue, submitForm, validateForm }) => {
                const selectedProgramDetails = {};
                return (
                  <Form onSubmit={handleSubmit}>
                    {isLoading ? (
                      <LoadingIndicator />
                    ) : isError ? (
                      <ErrorComponent />
                    ) : (
                      <>
                        {console.log("FORMIK VALUES ", values)}
                        {console.log("ERROR oF VALIDATION ", errors)}
                        <ViewPdfModal
                          publishPdfCheckbox={true}
                          isPopup={true}
                          show={pdfModal}
                          setShow={setPdfModal}
                          doc={document}
                          clientType={clientType}
                          handleSubmit={submitForm}
                          guardianList={data?.client_detail?.client_guardian_mapping}
                        />
                        <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                        <Row>
                          <Col lg="12" className="my-2">
                            <div className="bg-white session-report" style={{ overflow: "hidden", paddingBottom: "50px" }}>
                              <>
                                {(isFetching || submitting || copyReportLoading) && <LoadingOverlay />}

                                <div className="formBody reports-v2 pt-3">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "1px" }}>Chatter Program</h5>
                                      <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Summary Report</p>
                                    </div>
                                    {
                                      currentTab == 4 &&
                                      <div>
                                        <button
                                          onClick={(e) => { handleCopyReport(e, reportId, assessmentId); setCurrentEntry({ id: reportId, assesment_type: assessmentId }) }}
                                          type="button"
                                          className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        // disabled={isFetching || submitting || copyReportLoading}
                                        // isLoading={submitReportLoading || submitting}
                                        >
                                          Make a Copy
                                        </button>
                                      </div>
                                    }
                                  </div>
                                  <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                                    <div className="d-flex align-items-center gap_20">
                                      <div style={{ width: "20%" }}>
                                        <label style={{ fontSize: '14px' }} className="discharge-screen-label text-dark my-2">DATE OF REPORT</label>
                                        <AppDatePicker
                                          name="screening_date"
                                          className="w-100 py-2"
                                          disabled={previewMode}
                                        />
                                      </div>
                                      {
                                        [2, 3].includes(currentTab) && (
                                          <div className="mt-1" style={{ width: "80%" }}>
                                            <h6 className="date-title w-100">CLIENT INFORMATION</h6>
                                            <div className="d-flex text-dark align-items-center justify-content-between">
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>FIRST NAME</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.firstname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>LAST NAME</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.lastname}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>CITY/TOWN</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.city_town}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>DATE OF BIRTH</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{dateFormat(data?.client_detail?.dob, dobFormat)}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>GRADE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{data?.client_detail?.grad || "--"}</p>
                                              </div>
                                              <div>
                                                <h5 className="discharge-screen-label text-dark" style={{ fontSize: "10px" }}>AGE</h5>
                                                <p className="mb-0" style={{ fontSize: "14px" }}>{getAge(data?.client_detail?.dob)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        )
                                      }
                                    </div>
                                  </div>
                                  <TabStepper
                                    currentTab={currentTab}
                                    steps={[
                                      "CLIENT INFO",
                                      "PROGRAM INFO",
                                      "PROGRAM GOALS",
                                      "RECOMMENDATIONS",
                                    ]}
                                  />
                                  {currentTab === 1 ? (
                                    <div
                                      className="mt-4 client-view"
                                    >
                                      <ClientDetails
                                        showDOB
                                        data={data}
                                        heading="1. CLIENT INFORMATION"
                                        clientType={clientType}
                                      />
                                      {data?.client_detail?.client_guardian_mapping?.[0]?.client_guardian ?
                                        <>
                                          <>
                                            {[...data.client_detail.client_guardian_mapping?.filter((x) => x?.client_guardian?.client_role?.slug == "parent")] // clone the array
                                              .map((guardian, index) => {
                                                const slug = guardian?.client_guardian?.client_role?.slug;
                                                if (slug != "parent") {
                                                  return null;
                                                }

                                                return (
                                                  <ChatterGuardianDetailList
                                                    clientType={clientType}
                                                    previewMode={previewMode}
                                                    key={index}
                                                    index={index}
                                                    guardian={guardian}
                                                    slug={`${slug} ${index + 1}`}
                                                    values={values}
                                                  />
                                                );

                                              })}
                                          </>
                                          <>
                                            {[...data.client_detail.client_guardian_mapping] // clone the array
                                              .map((guardian, index) => {
                                                const slug = guardian?.client_guardian?.client_role?.slug;
                                                if (slug == "parent") {
                                                  return null;
                                                }

                                                return (
                                                  <ChatterGuardianDetailList
                                                    clientType={clientType}
                                                    previewMode={previewMode}
                                                    key={index}
                                                    index={index}
                                                    guardian={guardian}
                                                    slug={slug}
                                                    values={values}
                                                  />
                                                );

                                              })}
                                          </>
                                        </>
                                        : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />}
                                    </div>
                                  ) :
                                    currentTab === 2 ? (
                                      <>
                                        <h5 className="section-title mt-4">{"1. PROGRAM DESCRIPTION"}</h5>
                                        {reportQuestions?.length > 0 &&
                                          reportQuestions?.map((question, index) => {
                                            if (
                                              [
                                                CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.program_description,
                                              ].includes(question.id)
                                            ) {
                                              return (
                                                <div className={`py-4 ${index == 0 ? 'pt-2' : ''}`}>
                                                  <RenderQuestion
                                                    showQuestion={false}
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={index + 1}
                                                    onChange={handleSelectProgram}
                                                    assignedGroupLeaders={data?.assesment?.AssesmentGroupleaderAssigned}
                                                    caseVeteran={caseVeteran}
                                                  />
                                                </div>
                                              );
                                            }
                                          })}
                                        {/* <div className="d-flex align-items-start mt-3 gap-10 flex-wrap">
                                          <h6
                                            className="m-0 fw-sbold themeBlue"
                                            style={{ minWidth: 200, fontSize: 14 }}
                                          >
                                            Program Name:
                                          </h6>
                                          <Dropdown onSelect={(e) => handleSelectProgram(e, setFieldValue)}>
                                            <Dropdown.Toggle
                                              className={`text-capitalize  rounded-0 border-0 themeBlue p-0`}
                                              variant="transparent"
                                              id="dropdown-basic"
                                            >
                                              <div className="d-flex gap-1">
                                                <div>
                                                  <p>{selectedProgram?.name || "Select Program"}</p>
                                                </div>
                                                <span className="icn" style={{ marginRight: "20px" }}>
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12"
                                                    height="8"
                                                    viewBox="0 0 12 8"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                      fill="black"
                                                    />
                                                  </svg>
                                                </span>
                                              </div>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                                              {clientProgramList?.length > 0 ? clientProgramList?.map((item, index) => {
                                                return <Dropdown.Item key={index} eventKey={item?.id}><p>{item?.name}</p></Dropdown.Item>
                                              }) :
                                                <>
                                                  <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>
                                                </>
                                              }
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </div> */}
                                        {(programValidation) ? (
                                          <div className="error">{programValidation ? programValidation : ""}</ div>
                                        ) : null}
                                        <h5 className="section-title mt-4">{"2. GROUP LEADERS"}</h5>
                                        {
                                          selectedProgram?.leaders?.length ? selectedProgram?.leaders?.map((item, index) => (
                                            <div className="d-flex reports-guardian discharge-title gap-2">
                                              <input
                                                type="checkbox"
                                                className="form-check"
                                                style={{ accentColor: "#b46c9f", height: 20, width: 20, marginTop: "-3px" }}
                                                disabled={previewMode}
                                                onChange={(e) => {
                                                  const isChecked = e.target.checked;
                                                  // const role = index === 0 ? "teacher" : "coordinator";
                                                  const leaderData = { ...item, chatter_program_id: selectedProgram?.id };

                                                  const currentList = values.groupLeaderList?.length ? values.groupLeaderList?.filter(leader => leader?.chatter_program_id === selectedProgram?.id) : [];

                                                  let updatedList;
                                                  if (isChecked) {
                                                    updatedList = [...currentList, leaderData];
                                                  } else {
                                                    updatedList = currentList.filter((x) => x.id !== item?.id);
                                                  }

                                                  setFieldValue('groupLeaderList', updatedList);
                                                }}
                                                checked={values.groupLeaderList?.some((x) => x?.id === item?.id)}
                                              />
                                              <div className="w-100">
                                                <div className="reports-guardian-title" style={{ textTransform: "uppercase" }}>
                                                  {`Group Leader ${index + 1}`}
                                                </div>
                                                <div className="mb-3 mt-2 d-flex align-items-top" style={{ gap: "20px" }}>
                                                  <div style={{ width: "20%" }}>
                                                    <label className="discharge-screen-label">Last Name</label>
                                                    <input className="readonly-box" readOnly value={item?.lastname} />
                                                  </div>
                                                  <div style={{ width: "20%" }}>
                                                    <label className="discharge-screen-label">First Name</label>
                                                    {/* <div className="readonly-box">{guardian?.client_guardian?.firstname}</div> */}
                                                    <input className="readonly-box" readOnly value={item?.firstname} />
                                                  </div>
                                                  <div style={{ width: "33.5%" }}>
                                                    <label className="discharge-screen-label">Email</label>
                                                    {/* <div className="readonly-box">{guardian?.client_guardian?.email}</div> */}
                                                    <div className="d-flex align-items-center" style={{ height: "38px" }}>
                                                      <p className="text-black m-0">chatter@khan-services.com</p>
                                                    </div>
                                                  </div>
                                                  {/* <Col md={3}>
               <label>City/Town</label>
               <div className="readonly-box">{guardian?.client_guardian?.city}</div>
             </Col> */}
                                                </div>
                                              </div>
                                            </div>
                                          )) : <p>No program selected</p>
                                        }
                                        {(touched?.groupLeaderList && errors?.groupLeaderList) ? (
                                          <div className="error">{typeof errors?.groupLeaderList === "string" ? errors?.groupLeaderList : ""}</div>
                                        ) : null}
                                      </>
                                    ) :
                                      currentTab === 3 ? (
                                        <div className="recommendations">
                                          <h6 className="section-title w-100" style={{ marginBottom: "1px", marginTop: "24px" }}>
                                            PROGRAM GOALS
                                          </h6>
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.observation) return;
                                              return (
                                                <div className="pb-4">
                                                  {/* <RenderQuestion
                                                   key={index}
                                                   question={question}
                                                   fieldName={question.id}
                                                   questionIndex={1}
                                                   clientType={"school"}
                                                   assessmentId={assessmentId}
                                                 /> */}
                                                  <QuestionMultipleGoalsStrategy
                                                    assessmentData={data}
                                                    type="Goal"
                                                    showDate={false}
                                                    sliderRefs={sliderRefs}
                                                    chartRefs={chartRefs}
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    questionIndex={1}
                                                    clientType={"school"}
                                                    assessmentId={assessmentId}
                                                  />
                                                </div>
                                              );
                                            }
                                            )}
                                          {
                                            touched.observations && errors.observations ? (
                                              <div className="text-danger">{typeof (errors.observations) == "string" && errors.observations}</div>
                                            ) : null
                                          }
                                        </div>
                                      ) : (
                                        <div className="recommendations">
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (
                                                [
                                                  CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_summary,
                                                ].includes(question.id)
                                              ) {
                                                return (
                                                  <div className={`py-4 ${index == 0 ? 'pt-2' : ''}`}>
                                                    <RenderQuestion
                                                      key={index}
                                                      question={question}
                                                      fieldName={question.id}
                                                      questionIndex={1}
                                                    />
                                                  </div>
                                                );
                                              }
                                            })}
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (question.id !== CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.multiRecommendation) return;
                                              return (
                                                <div className="py-4">
                                                  {(
                                                    <h6 className="section-title w-100" style={{ marginBottom: "7px" }}>
                                                      {!isNaN(2) && `${2}. `}
                                                      {question?.question}
                                                    </h6>
                                                  )}
                                                  <QuestionMultipleRecommendation
                                                    key={index}
                                                    question={question}
                                                    fieldName={question.id}
                                                    fieldData={reportRecommendations}
                                                    questionIndex={1}
                                                    clientType={"school"}
                                                    assessmentId={assessmentId}
                                                    maxRecommendations={4}
                                                  />
                                                  {/* <RenderQuestion
                                                   key={index}
                                                   question={question}
                                                   fieldName={question.id}
                                                   fieldData={reportRecommendations}
                                                   questionIndex={1}
                                                   clientType={"school"}
                                                   assessmentId={assessmentId}
                                                 /> */}
                                                </div>
                                              );
                                            }
                                            )}
                                          {reportQuestions?.length > 0 &&
                                            reportQuestions?.map((question, index) => {
                                              if (
                                                [
                                                  CHATTER_CONSULTATION_REPORT_V2_QUESTIONS.clinical_presentation,
                                                ].includes(question.id)
                                              ) {
                                                return (
                                                  <div className={`py-4 ${index == 0 ? 'pt-2' : ''}`}>
                                                    <RenderQuestion
                                                      key={index}
                                                      question={question}
                                                      fieldName={question.id}
                                                      questionIndex={3}
                                                    />
                                                  </div>
                                                );
                                              }
                                            })}
                                          <div className="mb-2">
                                            <h6 className="section-title text-uppercase">
                                              2. signature
                                            </h6>
                                            <div className="d-flex gap-2 mt-2 align-items-center">
                                              <input
                                                type="checkbox"
                                                className="form-check"
                                                style={{ accentColor: "#b46c9f", height: 20, width: 20 }}
                                                disabled={previewMode}
                                                onChange={(e) => {
                                                  if (values?.student?.value) {
                                                    setFieldValue('apprentice_id', e.target.checked ? caseApprentice?.id : null);
                                                  }
                                                  else {
                                                    errorMessageToast("Please select the apprentice")
                                                  }
                                                }}
                                                checked={values.apprentice_id === caseApprentice?.id}
                                              />
                                              <div className="d-flex student-cstm-select flex-1 w-100 gap-2 align-items-center">
                                                <span className="proxima" style={{ fontSize: "14px" }}>Add Student:</span>
                                                <Col md='4'>
                                                  <AppSelect2Field
                                                    name='student'
                                                    option={caseApprentice?.therapist_id ? [{ label: userFullName(caseApprentice?.caseTherapist), value: caseApprentice?.therapist_id }] : []}
                                                    placeholder="Select a student..."
                                                    classNamePrefix="khan"
                                                  />
                                                </Col>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                  }
                                </div>
                              </>
                            </div>
                          </Col>
                          {/* <button type="button" onClick={() => getExample()}>
                           VIEW IMAGE
                         </button> */}
                          <Col lg="12" className="my-2">
                            <ReportError />
                            <div className='d-flex gap-3 align-items-center justify-content-between'>
                              <div>
                                {currentTab > 1 && (
                                  <button
                                    onClick={() => setCurrentTab(currentTab - 1)}
                                    type="button"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    <ArrowLeftIcon />
                                    {"Back"}
                                  </button>
                                )}
                              </div>
                              <div className="d-flex gap-3 align-items-center justify-content-between">
                                <ReportSubmitButton
                                  onClick={() => {
                                    setFieldValue('saveForLater', true)
                                    if (!selectedProgram?.name) {
                                      setProgramValidation("Please select the program.")
                                    }
                                  }}
                                  type="submit"
                                  className="d-flex gap-2 align-items-center justify-content-center save-discharge-screen"
                                  disabled={previewMode || isFetching || submitting}
                                // isLoading={submitReportLoading || submitting}
                                >
                                  Save
                                  <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.939684 1.3674L6.16086 6.18695C6.35239 6.36374 6.64761 6.36375 6.83914 6.18695L12.0603 1.3674C12.3948 1.05868 12.1763 0.500001 11.7212 0.500001L1.27883 0.5C0.82367 0.5 0.605235 1.05868 0.939684 1.3674Z" fill="white" />
                                  </svg>
                                </ReportSubmitButton>
                                {currentTab === 4 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                      // isLoading={submittingStep}
                                      disabled={isFetching || submitting}
                                      onClick={() => handleViewPdf(values)}
                                    >
                                      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                      </svg>
                                      Preview Report
                                    </button>
                                    {
                                      therapist?.role_type == "veteran" &&
                                      <ReportSubmitButton
                                        onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                        type="button"
                                        className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                        disabled={isFetching || submitting}
                                      // isLoading={submitReportLoading || submitting}
                                      >
                                        SUBMIT
                                        {/* <img width={14} height={8} src={arro_right_img} alt="arro_right_img" /> */}
                                      </ReportSubmitButton>
                                    }
                                  </>
                                ) : (
                                  <button
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (isEmpty(errors)) {
                                        setFieldValue('saveForLater', true);
                                        await submitForm();
                                        setCurrentTab(currentTab + 1);
                                      }
                                    }}
                                    type="submit"
                                    className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                    disabled={isFetching || submitting}
                                  // isLoading={submitReportLoading || submitting}
                                  >
                                    Next
                                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                    </svg>
                                  </button>
                                )}
                              </div>
                            </div>
                          </Col>

                        </Row>
                      </>
                    )}
                  </Form>
                )
              }
              }
            </Formik>
          </div>
        </Container>
      </section >
    </>
  );
};

export default ChatterConsultationReport;